import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountServiceProxy } from '../service-proxies';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent implements OnInit {

  ViewFileDate:any;
  safeSrc: SafeResourceUrl;

  modalRef: BsModalRef;
  constructor(private _activedRoute: ActivatedRoute,
    private _accountServiceProxy:AccountServiceProxy,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService,) { }
  fileid:any;
  ngOnInit() {

    this._activedRoute.queryParams.subscribe(parem => {
      this.fileid = parem.fileid;
 
      // this._accountServiceProxy.getProfilePictureById(this.fileid).subscribe(result => {
      //   this.ViewFileDate = 'data:video/mp4;base64,' + result.profilePicture;
      //     console.log(this.ViewFileDate);
      //   this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.ViewFileDate);
      // });
    });
  }
 
openModal(template: TemplateRef<any>) {
        this._accountServiceProxy.getProfilePictureById(this.fileid).subscribe(result => {
          this.ViewFileDate = 'data:video/mp4;base64,' + result.profilePicture;
          this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl(this.ViewFileDate);
          this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
        }, error => { });
 }
decline(event): void {

  this.modalRef.hide();
}

}
